<template>
  <woot-modal :show="show" :on-close="onClose" :header-title="modalTitle">
    <div class="space-y-5 max-w-[560px] bg-white p-4 sm:p-5 rounded-lg border border-gray-200">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ $t('IMAGE_LIBRARY.FORM.NAME') }} *</label>
        <input v-model="form.name" class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500" required maxlength="200" :placeholder="$t('IMAGE_LIBRARY.FORM.NAME_PLACEHOLDER')" />
        <div class="text-xs text-gray-500 mt-1">{{ $t('IMAGE_LIBRARY.FORM.NAME_HELP') }}</div>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">{{ $t('IMAGE_LIBRARY.FORM.DESCRIPTION') }}</label>
        <textarea v-model="form.description" rows="3" class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500" :placeholder="$t('IMAGE_LIBRARY.FORM.DESCRIPTION_PLACEHOLDER')" />
        <div class="text-xs text-gray-500 mt-1">{{ $t('IMAGE_LIBRARY.FORM.DESCRIPTION_HELP') }}</div>
      </div>
      <!-- Category field -->
      <div class="form-row">
        <label class="form-label">
          {{ $t('IMAGE_LIBRARY.FORM.CATEGORY') }}
        </label>
        <CategorySelector
          v-model="form.business_category_id"
          :categories="businessCategories"
          category-type="image_library"
          :placeholder="$t('IMAGE_LIBRARY.FORM.CATEGORY_PLACEHOLDER')"
          @category-created="onCategoryCreated"
        />
        <div class="form-help">
          {{ $t('IMAGE_LIBRARY.FORM.CATEGORY_HELP') }}
        </div>
      </div>
      
      <!-- Active toggle -->
      <div class="form-row">
        <div class="flex items-center">
          <woot-switch
            :model-value="form.is_active"
            @input="form.is_active = $event"
          />
          <span class="ml-3 text-sm font-medium text-gray-700">
            {{ $t('IMAGE_LIBRARY.FORM.ACTIVE') }}
          </span>
        </div>
        <div class="form-help">
          {{ $t('IMAGE_LIBRARY.FORM.ACTIVE_HELP') }}
        </div>
      </div>

      <!-- Actions in body (đảm bảo luôn hiển thị) -->
      <div class="flex justify-end gap-2 pt-4 border-t border-gray-200">
        <woot-button variant="clear" :disabled="isSubmitting" @click="onClose">{{ $t('COMMON.CANCEL') }}</woot-button>
        <woot-button :is-loading="isSubmitting" :disabled="!canSubmit" @click="onSubmit">{{ submitLabel }}</woot-button>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import CategorySelector from './CategorySelector.vue';

export default {
  name: 'LibraryModal',
  components: { CategorySelector },
  props: {
    show: { type: Boolean, default: false },
    accountId: { type: [String, Number], required: true },
    library: { type: Object, default: null },
    businessCategories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['close', 'saved', 'category-created'],
  data() {
    return {
      isSubmitting: false,
      form: {
        name: '', 
        description: '', 
        category: '', 
        business_category_id: null,
        is_active: true,
      },
    }
  },
  computed: {
    modalTitle() {
      return this.library ? this.$t('IMAGE_LIBRARY.EDIT_FOLDER') : this.$t('IMAGE_LIBRARY.ADD_FOLDER')
    },
    canSubmit() {
      return (this.form.name || '').trim().length > 0 && !this.isSubmitting
    },
    submitLabel() {
      return this.library ? this.$t('COMMON.UPDATE') : this.$t('COMMON.SAVE')
    }
  },
  watch: {
    library: {
      immediate: true,
      handler(v) {
        this.form = v ? { 
          name: v.name, 
          description: v.description, 
          category: v.category, 
          business_category_id: v.business_category_id || null,
          is_active: v.is_active 
        } : { 
          name: '', 
          description: '', 
          category: '', 
          business_category_id: null,
          is_active: true 
        }
      }
    }
  },
  methods: {
    onClose() { this.$emit('close') },
    
    onCategoryCreated(newCategory) {
      this.$emit('category-created', newCategory);
    },
    
    async onSubmit() {
      try {
        this.isSubmitting = true
        if (this.library) {
          await window.axios.put(`/api/v1/accounts/${this.accountId}/image_libraries/${this.library.id}`, { image_library: this.form })
        } else {
          await window.axios.post(`/api/v1/accounts/${this.accountId}/image_libraries`, { image_library: this.form })
        }
        this.$emit('saved')
      } finally {
        this.isSubmitting = false
      }
    },
  }
}
</script>


